/* global jQuery */
/* global SWDLocalise  */
import ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import Barba from 'barba.js';
import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/scrollTrigger';
import tingle from 'tingle.js';
import Handlebars from 'handlebars';
import Tooltip from 'tooltip.js';

ScrollMagicPluginGsap(ScrollMagic, gsap);

gsap.registerPlugin(ScrollTrigger);

const SWD = function($) {
    let SWDCache = {
        isAdmin: document.querySelector('.js-Admin') ? true : false,
    };

    let $window,
        Site = {
            callAll: function(f, data) {
                var o = [];

                for (o in Site) {
                    if (Site[o] !== null) {
                        if (f in Site[o]) {
                            Site[o][f](data);
                        }
                    }
                }
            },
            onLoad: function() {
                Site.callAll('onLoad');
            },
            onUnload: function() {
                Site.callAll('onUnload');
            },
            onResize: function(instant) {
                Site.callAll('onResize');
            },
            init: function() {
                $window.on('resize', Site.onResize);
                Site.onResize(true);
                Site.callAll('init');
                Site.callAll('onLoad');
            }
    };

    Site.pageTransition = {
        isAdmin: false,
        init: function () {
            if (SWDCache.isAdmin) {
                return;
            }

            document.addEventListener('DOMContentLoaded', (event) => {
                let page = document.querySelector('.js-Page');
                let transition = document.querySelector('.js-Transition');
                let fadeTransition = Barba.BaseTransition.extend({
                    start: function () {
                        /**
                         * This function is automatically called as soon the Transition starts
                         * this.newContainerLoading is a Promise for the loading of the new container
                         * (Barba.js also comes with an handy Promise polyfill!)
                         */
                        // As soon the loading is finished and the old page is faded out, let's fade the new page
                        Promise.all([this.newContainerLoading, this.initTransition()])
                            .then(this.fadeOut.bind(this))
                            .then(this.fadeIn.bind(this))
                            .then(this.finish.bind(this));
                    },

                    initTransition: function () {
                        transition.classList.add('is-active');
                    },

                    fadeOut: function () {
                        // this.oldContainer is the HTMLElement of the old Container
                        return $(this.oldContainer).animate({
                            opacity: 0
                        }).promise();
                    },

                    fadeIn: function () {
                        if (page.classList.contains('has-overlaid-header')
                            && this.newContainer.dataset.namespace !== 'project') {
                            page.classList.remove('has-overlaid-header');
                        }

                        if (!page.classList.contains('has-overlaid-header')
                            && this.newContainer.dataset.namespace === 'project') {
                            page.classList.add('has-overlaid-header');
                        }

                        // close nav
                        Site.nav.closeNav();

                        // close search
                        // Site.search.close();

                        /**
                         * this.newContainer is the HTMLElement of the new Container
                         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
                         * Please note, newContainer is available just after newContainerLoading is resolved!
                         */

                        let $el = $(this.newContainer);

                        $(this.oldContainer).hide();

                        $el.css({
                            visibility: 'visible',
                            opacity: 0
                        }).animate({
                            opacity: 1
                        }, 100);
                    },

                    finish: function () {
                        imagesLoaded(this.newContainer, {
                            background: true
                        }, () => {
                            this.done();
                            window.scrollTo(0, 0);
                        });
                    }
                });

                // start barba
                Barba.Pjax.start();

                Barba.Pjax.getTransition = function () {
                    return fadeTransition;
                };

                Barba.Dispatcher.on('initStateChange', function (currentStatus) {
                    // send pageview to Google Analytics
                    if (Barba.HistoryManager.history.length <= 1) {
                        return;
                    }
                    if (typeof gtag === 'function') {
                        // send statics by Google Analytics(gtag.js)
                        gtag('config', 'UA-87981811-1', {
                            'page_path': location.pathname,
                            'use_amp_client_id': true
                        });
                    } else {
                        // send statics by Google Analytics(analytics.js) or Google Tag Manager
                        if (typeof ga === 'function') {
                            var trackers = ga.getAll();
                            trackers.forEach(function (tracker) {
                                ga(tracker.get('name') + '.send', 'pageview', location.pathname, {
                                    'useAmpClientId': true
                                });
                            });
                        }
                    }
                });

                // always set scroll position to top of the page
                Barba.Dispatcher.on('newPageReady', function (current, prev, container) {
                    history.scrollRestoration = 'manual';
                });

                Barba.Dispatcher.on('transitionCompleted', function (currentStatus, prevStatus) {
                    transition.classList.add('is-leaving');
                    Site.nav.init();
                    // Site.search.initSearch();
                    Site.lazyLoad.init();
                    Site.animations.init();
                    Site.engine.init();
                    Site.parallax.init();
                    Site.stats.init();
                    // Site.sidebar.init();
                    Site.slider.init();
                    Site.select.init();
                    Site.modalVideo.init();
                    Site.modalForm.init();
                    Site.socialShare.init();
                    Site.posts.init();
                    Site.sendForm.init();
                    Site.events.init();

                    // reset transition element classes
                    setTimeout(function () {
                        transition.classList.remove('is-active', 'is-leaving');
                    }, 650);
                });
            });
        }
    };

    Site.nav = {
        _btn: $('.js-OpenNav'),
        init: function () {
            Site.nav.events();

            $('.js-Nav .c-Nav_Link-0').each(function () {
                var $this = $(this);
                var href = $this.attr('href');
                $this.parent().removeClass('is-current');
                if (href == $(location).attr('href')) {
                    $this.parent().addClass('is-current');
                }
            });
        },
        openNav: function () {
            $(this._btn).toggleClass('is-active');
            $('html').toggleClass('has-open-nav');
        },
        openSubnav: function (e) {
            e.preventDefault();
            let targetMenu = $(e.currentTarget).parent().next();
            $('.c-Nav_Submenu').not(targetMenu).removeClass('is-open');
            targetMenu.toggleClass('is-open');
        },
        closeNav: function () {
            $(this._btn).removeClass('is-active');
            $('html').removeClass('has-open-nav');
            $('.c-Nav_Submenu').removeClass('is-open');
        },
        onResize: function () {
            if (window.matchMedia('(min-width: 1200px)').matches) {
                $('.js-OpenSubnav').off('click.openSubnav');
            } else {
                $('.js-OpenSubnav').off().on('click.openSubnav', function (e) {
                    this.openSubnav(e);
                }.bind(this));
            }
        },
        events: function () {
            this._btn.off().on('click', function () {
                this.openNav();
            }.bind(this));
        }
    };

    // Site.search = {
    //     _target: document.documentElement,
    //     _openBtn: document.querySelector('.js-OpenSearch'),
    //     _closeBtn: document.querySelector('.js-CloseSearch'),
    //     init: function () {
    //         this.initSearch();
    //         this.events();
    //     },
    //     open: function () {
    //         if (this._target.classList.contains('has-open-search')) {
    //             $('.algolia-autocomplete').remove();
    //         } else {
    //             this.initSearch();
    //         }
    //         this._target.classList.toggle('has-open-search');
    //     },
    //     close: function () {
    //         $('.algolia-autocomplete').remove();
    //         this._target.classList.remove('has-open-search');
    //     },
    //     initSearch: function () {
    //         /* init Algolia client */
    //         var client = algoliasearch(algolia.application_id, algolia.search_api_key);

    //         /* setup default sources */
    //         var sources = [];

    //         $.each(algolia.autocomplete.sources, function (i, config) {
    //             var suggestion_template = wp.template(config.tmpl_suggestion);
    //             sources.push({
    //                 source: algoliaAutocomplete.sources.hits(client.initIndex(config.index_name), {
    //                     hitsPerPage: config.max_suggestions,
    //                     attributesToSnippet: [
    //                         'content:10'
    //                     ],
    //                     highlightPreTag: '__ais-highlight__',
    //                     highlightPostTag: '__/ais-highlight__'
    //                 }),
    //                 templates: {
    //                     header: function () {
    //                         return wp.template('autocomplete-header')({
    //                             label: _.escape(config.label)
    //                         });
    //                     },
    //                     suggestion: function (hit) {
    //                         if (hit.escaped === true) {
    //                             return suggestion_template(hit);
    //                         }
    //                         hit.escaped = true;

    //                         for (var key in hit._highlightResult) {
    //                             /* We do not deal with arrays. */
    //                             if (typeof hit._highlightResult[key].value !== 'string') {
    //                                 continue;
    //                             }
    //                             hit._highlightResult[key].value = _.escape(hit._highlightResult[key].value);
    //                             hit._highlightResult[key].value = hit._highlightResult[key].value.replace(/__ais-highlight__/g, '<em>').replace(/__\/ais-highlight__/g, '</em>');
    //                         }

    //                         for (var key2 in hit._snippetResult) {
    //                             /* We do not deal with arrays. */
    //                             if (typeof hit._snippetResult[key2].value !== 'string') {
    //                                 continue;
    //                             }

    //                             hit._snippetResult[key2].value = _.escape(hit._snippetResult[key2].value);
    //                             hit._snippetResult[key2].value = hit._snippetResult[key2].value.replace(/__ais-highlight__/g, '<em>').replace(/__\/ais-highlight__/g, '</em>');
    //                         }

    //                         return suggestion_template(hit);
    //                     }
    //                 }
    //             });
    //         });

    //         /* Setup dropdown menus */
    //         $(algolia.autocomplete.input_selector).each(function (i) {
    //             var $searchInput = $(this);

    //             var config = {
    //                 debug: algolia.debug,
    //                 hint: false,
    //                 openOnFocus: true,
    //                 appendTo: 'body',
    //                 templates: {
    //                     empty: wp.template('autocomplete-empty')
    //                 }
    //             };

    //             /* Instantiate autocomplete.js */
    //             var autocomplete = algoliaAutocomplete($searchInput[0], config, sources)
    //                 .on('autocomplete:selected', function (e, suggestion) {
    //                     e.preventDefault();
    //                     /* Redirect the user when we detect a suggestion selection. */
    //                     // window.location.href = suggestion.permalink;
    //                 });

    //             /* Force the dropdown to be re-drawn on scroll to handle fixed containers. */
    //             $(window).scroll(function () {
    //                 if (autocomplete.autocomplete.getWrapper().style.display === "block") {
    //                     autocomplete.autocomplete.close();
    //                     autocomplete.autocomplete.open();
    //                 }
    //             });
    //         });
    //     },
    //     events: function () {
    //         this._openBtn.addEventListener('click', function () {
    //             this.open();
    //         }.bind(this));

    //         this._closeBtn.addEventListener('click', function (e) {
    //             e.preventDefault();
    //             this.close();
    //         }.bind(this));
    //     }
    // };

    Site.lazyLoad = {
        className: 'is-loading',
        init: function () {
            this.imageList = document.getElementsByClassName(this.className);
            this.scan();
        },
        scan: function () {
            this.imageList = this.imageList;

            for (var index = -1; ++index < this.imageList.length;) {
                let img = this.imageList[index];

                gsap.to(img, {
                    scrollTrigger: {
                        trigger: img,
                        start: 'top bottom',
                        onEnter: () => this.loadImage(img),
                    },
                });
            }
        },
        loadImage: function (img) {
            var src = img.getAttribute('data-src');

            if (src && img.classList.contains(this.className)) {
                img.onload = function (img) {
                    img.classList.remove(this.className);

                    var parent = img.parentNode.parentNode;
                    parent.classList.add('is-triggered');

                    Site.slider.repositionSlider();
                }.bind(this, img);

                img.onerror = function (img) {
                    img.classList.remove(this.className);
                }.bind(this, img);

                if (img.src === src) {
                    img.onload(img);
                } else {
                    img.src = src;
                }
            }
        }
    };

    Site.animations = {
        init: function () {
            this.DOM = {
                els: document.querySelectorAll('.js-animate'),
            };

            this.animate();
        },
        animate: function () {
            this.DOM.els.forEach((element) => {
                gsap.to(element, {
                    duration: 0.4,
                    y: 0,
                    opacity: 1,
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 85%',
                    },
                });
            });
        },
    };

    Site.engine = {
        init: function () {
            if (window.matchMedia('(max-width: 991px)').matches) {
                return;
            }

            this.fns = [];
            this.cache = {};
            this.loop = this.loop.bind(this);
            this.handleResize = this.handleResize.bind(this);
            this.handleResize();
            this.loop();
            window.addEventListener('resize', this.handleResize);
        },
        add: function (t) {
            if ('function' != typeof t) {
                throw new Error('RA: added param is not a function.');
            }

            this.fns.push(t);
        },
        handleResize: function () {
            this.cache.lastPosition = window.scrollY;
            this.cache.ww = window.innerWidth;
            this.cache.wh = window.innerHeight;
        },
        loop: function () {
            var t = void 0;

            for (this.cache.lastPosition = window.scrollY, t = this.fns.length; t--;) {
                this.fns[t](this.cache);
            }

            requestAnimationFrame(this.loop);
        },
    };

    Site.parallax = {
        init: function () {
            if (window.matchMedia('(prefers-reduced-motion)').matches) {
                return;
            }

            if (window.matchMedia('(max-width: 991px)').matches) {
                return;
            }

            this._positions = [];
            this.initMovingElements();
            this.updateElementsPosition = this.updateElementsPosition.bind(this);
            Site.engine.add(this.updateElementsPosition);
        },
        initMovingElements: function () {
            var t, e, n, o, r, i, s, c = document.querySelectorAll('[data-ps]');

            for (s = c.length; s--;) {
                t = parseFloat(c[s].getAttribute('data-ps-start-percent')) || 0;
                e = parseFloat(c[s].getAttribute('data-ps-start-x')) || 0;
                n = parseFloat(c[s].getAttribute('data-ps-start-y')) || 0;
                o = parseFloat(c[s].getAttribute('data-ps-end-percent')) || 1;
                r = parseFloat(c[s].getAttribute('data-ps-end-x')) || 0;
                i = parseFloat(c[s].getAttribute('data-ps-end-y')) || 0;

                this._positions.push({
                    el: c[s],
                    container: {
                        element: c[s].parentNode
                    },
                    start: {
                        percent: t,
                        x: e,
                        y: n
                    },
                    end: {
                        percent: o,
                        x: r,
                        y: i
                    },
                    diff: {
                        percent: o - t,
                        x: r - e,
                        y: i - n
                    },
                    reset: c[s].getAttribute('style')
                });
            }
        },
        getScrollPercent: function (t, e) {
            var n = t.container.element.scrollHeight + e.wh;
            return (e.wh - t.container.element.getBoundingClientRect().top) / n || 0;
        },
        updateElementsPosition: function (t) {
            var e = void 0,
                n = void 0,
                o = void 0,
                r = void 0,
                i = void 0,
                s = void 0,
                c = void 0;

            for (e = this._positions.length; e--;) {
                r = this._positions[e];

                if (Site.engine.cache.ww < 992) {
                    r.el.setAttribute('style', r.reset);
                } else {
                    i = r.el.scrollWidth;
                    s = r.el.scrollHeight;
                    c = this.getScrollPercent(r, t);

                    if (c <= r.start.percent) {
                        n = r.start.x * i;
                        o = r.start.y * s;
                    } else {
                        if (c >= r.end.percent) {
                            n = r.end.x * i;
                            o = r.end.y * s;
                        } else {
                            n = r.start.x * i + r.diff.x * (c - r.start.percent) / r.diff.percent * i;
                            o = r.start.y * s + r.diff.y * (c - r.start.percent) / r.diff.percent * s;
                        }
                    }

                    r.el.style.transform = "translate3d(" + n + "px, " + o + "px, 0px)";
                }
            }
        },
    };

    Site.stats = {
        init: function () {
            const container = document.querySelector('.js-stats');
            if (!container) return;

            const items = [...document.querySelectorAll('.js-stats-item')];
            const btns = [...document.querySelectorAll('.js-stats-nav-btn')];

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: 'top top',
                    end: `${items.length * 400}px`,
                    scrub: true,
                    pin: true,
                },
            })
                .to(items[0], {
                    duration: 0.01,
                    y: 20,
                    opacity: 0,
                });

            (items.slice(1, items.length)).forEach((element, idx, array) => {
                if (idx === array.length - 1) {
                    tl
                        .set(btns[btns.length - 1], {
                            backgroundColor: 'white',
                        })
                        .to(element, {
                            duration: 2,
                            y: 0,
                            opacity: 1,
                        });
                    return;
                }

                tl
                    .set(btns[idx + 1], {
                        backgroundColor: 'white',
                    })
                    .to(element, {
                        duration: 2,
                        y: 0,
                        opacity: 1,
                    })
                    .to(element, {
                        duration: 0.01,
                        y: 20,
                        opacity: 0,
                    });
            });

            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 2000);
        },
    };

    // Site.sidebar = {
    //     init: function () {
    //         if (window.matchMedia('(max-width: 991px)').matches) {
    //             return;
    //         }

    //         this.container = document.querySelector('.js-PostContainer');
    //         if (! this.container) {
    //             return;
    //         }

    //         this.controller = new ScrollMagic.Controller();

    //         this.sidebar = this.container.querySelector('.js-PostSidebar');
    //         if (this.sidebar) {
    //             let stickyNav = new ScrollMagic.Scene({
    //                     duration: this.container.offsetHeight - this.sidebar.offsetHeight - 40,
    //                     offset: -48,
    //                     triggerElement: '.js-PostSidebarTrigger',
    //                     triggerHook: 0,
    //                 })
    //                 .setPin(this.sidebar)
    //                 .addTo(this.controller);
    //         }
    //     }
    // };

    Site.slider = {
        init: function () {
            this.DOM = {
                sliders: document.querySelectorAll('.js-Slider'),
            };

            if (this.DOM.sliders.length < 1) {
                return;
            }

            // handle equal height slider items
            Flickity.prototype._createResizeClass = function () {
                this.element.classList.add('flickity-resize');
            };

            Flickity.createMethods.push('_createResizeClass');

            let resize = Flickity.prototype.resize;
            Flickity.prototype.resize = function () {
                this.element.classList.remove('flickity-resize');
                resize.call(this);
                this.element.classList.add('flickity-resize');
            };

            this.DOM.sliders.forEach((slider) => {
                this.createSlider(slider);
            });
        },
        createSlider: function (ele) {
            // show
            ele.classList.remove('is-hidden');

            // trigger redraw for transition
            var sliderHeight = ele.offsetHeight;
            var flkty = Flickity.data(ele);

            if (flkty === undefined) {
                var options = ele.dataset;
                var slider = new Flickity(ele, {
                    cellAlign: options.cellalign !== undefined ? options.cellalign : 'left',
                    cellSelector: '.js-SliderItem',
                    imagesLoaded: true,
                    prevNextButtons: false,
                    pageDots: false,
                    contain: true,
                    fade: options.fade !== undefined ? (options.fade === 'true') : false,
                    autoPlay: options.autoplay !== undefined ? (options.autoplay === 'true' ? 5000 : false) : false,
                    wrapAround: options.wraparound !== undefined ? (options.wraparound === 'true') : false,
                    // adaptiveHeight: true,
                    initialIndex: options.initialindex !== undefined ? options.initialindex : 0,
                });

                // previous/next
                var previousButton = ele.querySelector('.js-SliderNavPrev');
                var nextButton = ele.querySelector('.js-SliderNavNext');
                if (previousButton && nextButton) {
                    previousButton.addEventListener('click', () => {
                        slider.previous();
                    });

                    nextButton.addEventListener('click', () => {
                        slider.next();
                    });
                }

                // thumbnails
                if (options.thumbs !== undefined && options.thumbs) {
                    var thumbnails = ele.parentNode.querySelectorAll('.js-SliderThumb');
                    if (thumbnails.length > 0) {
                        thumbnails.forEach((thumbnail, i) => {
                            thumbnail.addEventListener('click', () => {
                                slider.select(i);
                                slider.pausePlayer();
                            });
                        });

                        slider.on('select', function () {
                            thumbnails.forEach((thumbnail) => {
                                thumbnail.classList.remove('is-selected');
                            });

                            thumbnails[slider.selectedIndex].classList.add('is-selected');
                        });
                    }
                }

                // events
                if (previousButton && nextButton) {
                    const slideCount = slider.cells.length;
                    slider.on('select', (index) => {
                        if (index == 0) {
                            previousButton.classList.add('is-disabled');
                            return;
                        }
                        previousButton.classList.remove('is-disabled');

                        if (index == (slideCount - 1)) {
                            nextButton.classList.add('is-disabled');
                            return;
                        }
                        nextButton.classList.remove('is-disabled');
                    });
                }

                setTimeout(() => {
                    ScrollTrigger.refresh();
                }, 1000);
            }
        },
        repositionSlider: function () {
            if (this.DOM.sliders.length < 1) return;

            this.DOM.sliders.forEach((slider) => {
                const flkty = Flickity.data(slider);
                if (flkty !== undefined) flkty.resize();
            });
        },
    };

    Site.select = {
        init: function() {
            this.DOM = {
                inputs: document.querySelectorAll('.js-Select')
            };

            if (this.DOM.inputs.length < 1) {
                return;
            }

            [...this.DOM.inputs].forEach((input, idx, array) => {
                input.addEventListener('change', (event) => {
                    if (SWDCache.isAdmin) {
                        window.location = input.value;
                    }
                    Barba.Pjax.goTo(input.value);
                });
            });
        }
    };

    Site.modal = {
        _modal: null,
        _timeline: null,
        initModal: function (type, onOpenCallback, onCloseCallback, dataset) {
            this._modal = new tingle.modal({
                closeMethods: ['overlay', 'escape'],
                footer: false,
                stickyFooter: false,
                cssClass: ['c-Modal' + type],
                onOpen: function () {
                    this._timeline = gsap.timeline({
                        onComplete: function () {
                            Site.modal.reposition();
                        }
                    });
                    this.reveal(onOpenCallback, dataset);
                }.bind(this),
                onClose: function () {
                    onCloseCallback();
                    this._timeline.kill();
                    document.querySelector('.tingle-modal').remove();
                }.bind(this),
            });

            let content = '';

            if (type == 'Form') {
                let source = document.getElementById('form').innerHTML;
                let template = Handlebars.compile(source);

                content = template();
            } else if (type == 'Video') {
                content = '<div class="c-Video">' +
                    '<iframe width="640"' +
                        'height="360"' +
                        'src="https://www.youtube.com/embed/' + dataset.video + '?autoplay=1"' +
                        'frameborder="0"' +
                        'allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"' +
                        'allowfullscreen></iframe>' +
                '</div>';
            }

            this._modal.setContent(
                '<div class="c-Modal_Inner js-ModalContents">' +
                    '<div class="c-Modal_Content js-ModalContentsInner">' +
                        content +
                    '</div>' +
                    '<button class="c-Modal_Close js-CloseModal">' +
                        '<span class="c-Icon c-Icon-close c-Modal_CloseIcon"></span>' +
                        '<span class="u-VisuallyHidden">Close</span>' +
                    '</button>' +
                '</div>'
            );
            this._modal.open();

            $('.js-CloseModal').off().on('click', () => {
                onCloseCallback();
                this._modal.close();
            });
        },
        reveal: function (onOpenCallback, dataset) {
            let $container = $('.tingle-modal .js-ModalContents');
            let $content = $container.find('.js-ModalContentsInner');

            $content.show();
            this._timeline.from($content, {
                duration: 0.6,
                height: 0,
            });

            this._timeline.call(function () {
                $container.addClass('is-ready');
            }, null, null, 0.5);

            onOpenCallback(dataset);
        },
        reposition: function () {
            if (this._modal !== undefined && this._modal !== null) {
                $('.js-ModalContentsInner').css('height', '');
                this._modal.checkOverflow();
            }
        },
    };

    Site.modalVideo = {
        init: function () {
            this.events();
        },
        destroy: function () {},
        onOpen: function (dataset) {},
        onClose: function () {
            Site.modalVideo.destroy();
        },
        events: function () {
            $('.js-OpenModalVideo').on('click', function (e) {
                Site.modal.initModal('Video', this.onOpen, this.onClose, e.currentTarget.dataset);
            }.bind(this));
        }
    };

    Site.modalForm = {
        init: function () {
            this.events();
        },
        destroy: function () {},
        onOpen: function (dataset) {
            Site.sendForm.events();
        },
        onClose: function () {
            Site.modalForm.destroy();
        },
        events: function () {
            $('.js-OpenModalForm').on('click', function (e) {
                e.preventDefault();
                Site.modal.initModal('Form', this.onOpen, this.onClose, e.currentTarget.dataset);
            }.bind(this));
        }
    };

    Site.socialShare = {
        init: function () {
            this.events();
        },
        doPopup: function (e) {
            e = (e ? e : window.event);
            var t = (e.currentTarget ? e.currentTarget : e.srcElement);
            var width = t.data - width || 800;
            var height = t.data - height || 500;

            // popup position
            var px = Math.floor(((screen.availWidth || 1024) - width) / 2);
            var py = Math.floor(((screen.availHeight || 700) - height) / 2);

            // open popup
            var popup = window.open(t.href, "social",
                "width=" + width + ",height=" + height +
                ",left=" + px + ",top=" + py +
                ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

            if (popup) {
                popup.focus();
                if (e.preventDefault) {
                    e.preventDefault();
                }
                e.returnValue = false;
            }

            return !!popup;
        },
        events: function () {
            $('.js-SocialLink').on('click', function (e) {
                this.doPopup(e);
            }.bind(this));
        },
    };

    Site.posts = {
        init: function () {
            this._loader = $('.js-LoadPosts');
            if (this._loader.length < 1) {
                return;
            }

            this.events();
        },
        loadPosts: function (btn, container) {
            let visiblePosts = container.find('.js-Post').length;

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: SWDLocalise.ajaxUrl,
                data: {
                    'offset': visiblePosts,
                    'action': btn.data('action'),
                    'post_type': btn.data('post-type'),
                    'posts_per_page': btn.data('posts-per-page'),
                    'filter': btn.data('filter'),
                },
                success: function (response) {
                    var posts = $(response.posts);
                    visiblePosts = visiblePosts + posts.length;

                    if (posts.length) {
                        posts.css({ opacity: 0 });
                        container.append(posts);
                        posts.animate({ opacity: 1 });
                        Site.lazyLoad.init();
                    }

                    if (visiblePosts == parseInt(response.total) || parseInt(response.total) == 0) {
                        btn.remove();
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log($.JSON.parse(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                }
            });
        },
        events: function () {
            this._loader.on('click', function (event) {
                let btn = event.currentTarget;
                this.loadPosts($(btn), $(btn).parent().parent().find('.js-Posts'));
            }.bind(this));
        }
    };

    Site.sendForm = {
        init: function () {
            Site.sendForm._notice = '';
            Site.sendForm._contents = '';

            this.events();
        },
        validateEmail: function (email, form) {
            form.addClass('is-disabled is-loading').fadeTo(0, 1).fadeTo(400, 0.6);

            $.ajax({
                type: 'POST',
                url: SWDLocalise.ajaxUrl,
                data: {
                    email: email,
                    action: 'swd_validate_email'
                },
                dataType: 'json',
                success: function (response) {
                    if (response.result == 'deliverable') {
                        Site.sendForm.send(form);
                    } else {
                        if (response.did_you_mean) {
                            Site.sendForm.errorNotice('Error, did you mean <em>' + response.did_you_mean + '</em>?');
                        } else {
                            Site.sendForm.errorNotice('The entered mail address is invalid.');
                        }

                        form.removeClass('is-disabled is-loading').stop(true, true).fadeTo(400, 1);
                        return false;
                    }
                },
                error: function (request, status_text, error) {
                    Site.sendForm.errorNotice('Error occurred, unable to validate your email address.');
                    form.removeClass('is-disabled is-loading').stop(true, true).fadeTo(400, 1);
                    return false;
                }
            }).fail(function () {
                alert('Sorry, there was an unknown error, please try submitting the form again.');
                form.removeClass('is-disabled is-loading').stop(true, true).fadeTo(400, 1);
            });
        },
        send: function (form) {
            $.ajax({
                type: 'POST',
                url: SWDLocalise.ajaxUrl,
                data: form.serialize(),
                dataType: 'json',
                success: function (response) {
                    if (response.status == 'success') {
                        form.trigger('reset');
                        Site.sendForm._contents.remove();
                        Site.sendForm.successNotice(response.message);
                    } else {
                        Site.sendForm.errorNotice(response.message);
                    }
                }
            }).always(function () {
                form.removeClass('is-disabled is-loading').stop(true, true).fadeTo(400, 1);
            });
        },
        successNotice: function (message) {
            Site.sendForm._notice
                .empty()
                .append('<div class="c-Notice c-Notice-success">' + message + '</div>');
            Site.modal.reposition();
        },
        errorNotice: function (message) {
            Site.sendForm._notice
                .empty()
                .append('<div class="c-Notice c-Notice-error">' + message + '</div>');
            Site.modal.reposition();
        },
        events: function () {
            $(document).off().on('submit', '.js-AjaxForm', function (e) {
                e.preventDefault();

                let $form = $(this);

                // form notice
                Site.sendForm._notice = $form.find('.js-FormNotice');
                Site.sendForm._notice.empty();

                // form contents
                Site.sendForm._contents = $form.find('.js-FormContents');

                let $inputs = $form.find('.js-FormInput');
                let userEmail = $('.js-FormEmail').val();
                let send = true;
                let errorMessage = 'One or more of the required fields are empty.';

                if ($form.hasClass('is-disabled')) {
                    return false;
                }

                // required fields
                $.each($inputs, $.proxy(function (i, input) {
                    input.classList.remove('has-error');

                    if (input.classList.contains('is-required') && !input.value) {
                        send = false;
                        input.classList.add('has-error');
                    }
                }, this));

                // terms
                $('.js-FormTermsBox').removeClass('has-error');
                if ($('.js-FormTerms').prop('checked') != true) {
                    send = false;
                    errorMessage = 'Please agree to our terms before proceeding. <br />'+errorMessage;
                    $('.js-FormTermsBox').addClass('has-error');
                }

                if (! send) {
                    Site.sendForm.errorNotice(errorMessage);
                    return false;
                }

                Site.sendForm.validateEmail(userEmail, $form);
            });
        }
    };

    Site.events = {
        init: function () {
            this._target = document.querySelector('.js-Calendar');
            if (! this._target) {
                return;
            }

            this.createSlider(this._target);
            this.initTooltips();
        },
        createSlider: function (ele) {
            // show
            ele.classList.remove('is-hidden');

            // trigger redraw for transition
            var sliderHeight = ele.offsetHeight;
            var flkty = Flickity.data(ele);

            if (flkty === undefined) {
                var calendarItems = document.querySelectorAll('.js-CalendarMonth');
                var calendar = new Flickity(ele, {
                    cellAlign: 'center',
                    cellSelector: '.js-CalendarMonth',
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: false,
                    on: {
                        change: function (index) {
                            var month = calendarItems[index].getAttribute('data-month');
                            var year = calendarItems[index].getAttribute('data-year');
                            $('.js-CalendarCurrent').text(month + ' ' + year);
                        }
                    }
                });

                // prev/next buttons
                var previousButton = document.querySelector('.js-CalendarPrev');
                if (previousButton) {
                    previousButton.addEventListener('click', function () {
                        calendar.previous();
                    });
                }

                var nextButton = document.querySelector('.js-CalendarNext');
                if (nextButton) {
                    nextButton.addEventListener('click', function () {
                        calendar.next();
                    });
                }
            }
        },
        initTooltips: function () {
            var tooltips = document.querySelectorAll('.js-Tooltip');
            if (tooltips) {
                tooltips.forEach((ele) => {
                    var contents = ele.getAttribute('data-events');
                    var instance = new Tooltip(ele, {
                        placement: 'left',
                        innerSelector: '.c-Tooltip_Inner',
                        container: this._target,
                        title: function () {
                            var html = '';

                            JSON.parse(contents).forEach((event) => {
                                html += '<div class="c-Tooltip_Block js-Block">';
                                html += '<div class="c-Tooltip_BlockInner">';
                                if (event[5] != '') {
                                    html += '<span class="o-M30 c-Tooltip_BlockProject u-ColorBlueDark">' + event[5] + '</span>';
                                }
                                html += '<strong class="c-Tooltip_BlockTitle">' + event[4] + '</strong>';
                                html += '<h4 class="o-M15 c-Tooltip_BlockTitle u-ColorWhite">' + event[3] + '</h4>';
                                html += '<a href="' + event[2] + '" target="_blank" class="c-Tooltip_BlockBtn js-BlockBtn"><strong>View event</strong></a>';
                                html += '</div>';
                                html += '</div>';
                            });

                            return html;
                        },
                        trigger: 'click',
                        html: true,
                        template: '<div class="tooltip c-Tooltip" role="tooltip"><div class="c-Tooltip_Inner"></div></div>',
                        popperOptions: {
                            onCreate: function (data) {
                                $(document).on('click', function (e) {
                                    if ($(e.target).hasClass('js-BlocksBtn')) {
                                        return;
                                    }
                                    instance.hide();
                                });
                            },
                            onUpdate: function (data) {
                                $(document).on('click', function (e) {
                                    if ($(e.target).hasClass('js-BlocksBtn')) {
                                        return;
                                    }
                                    instance.hide();
                                });
                            }
                        }
                    });
                });
            }
        }
    };

    $window = $(window);

    Site.init();
}(jQuery);
